import React, { useEffect, useRef, forwardRef } from 'react';
import styles from './captcha.module.css';

const Captcha = forwardRef(({ generateCode, setValidCaptcha, code, key=0 }, ref) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    initializeCaptcha(ctx);

    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    if (e.target.value === code) {
      setValidCaptcha(true);
    } else {
      setValidCaptcha(false);
    }
  }

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ['rgb(0,0,0)', 'rgb(130,130,130)'];
    const letterSpace = 220 / captcha.length;
    for (let i = 0; i < captcha.length; i++) {
      const xInitialSpace = 15;
      ctx.font = '30px Roboto Mono';
      ctx.fillStyle = textColors[Math.floor(Math.random() * 2)];
      ctx.fillText(
        captcha[i],
        xInitialSpace + i * letterSpace,
        // Randomize Y position slightly
        Math.floor(Math.random() * 36 + 25),
        100
      );
    }
  };

  const initializeCaptcha = (ctx) => {
    const newCaptcha = generateCode();
    drawCaptchaOnCanvas(ctx, newCaptcha);
    setValidCaptcha(false);
  };

  return (
    <div className={styles.captcha_container} id='captcha'>
      <div className={styles.wrapper}>
        <canvas
          className={styles.canvas}
          ref={canvasRef}
          width="250"
          height="70"
        >
        </canvas>
        <button className={styles.captcha_button}
          type='button'
          id="reload-button"
          onClick={
            () => { initializeCaptcha(canvasRef.current.getContext('2d')) }
          }
        />
      </div>
      <input
        name="captcha-code"
        id="captcha-code"
        className={styles.captcha_input}
        type="text"
        placeholder="Код с картинки"
        ref={ref}
        onChange={handleChange}
        autoComplete="off"
      />
    </div>
  );
});

export default Captcha;
